import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from '../../services/toasts.service';
import { take } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/auth.service';
import { PlanogramApiService } from '../../services/planogram-api.service';
import { PlanogramService } from '../../services/planogram.service';
import { RolesService } from '../../services/roles.service';
import { SignalRService } from 'src/app/services/signalr.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [FormsModule]
})
export class LoginComponent {
  public email: string = "";
  public password: string = "";

  constructor(
    private router: Router,
    private authService: AuthService,
    private toastService: ToastService,
    private planogramApiService: PlanogramApiService,
    private planogramService: PlanogramService,
    private rolesService: RolesService,
    private signalRService: SignalRService) { }

  login(){
    if(this.email.length == 0 || !this.validateEmail()){
      this.toastService.show(`Please enter an valid email to login.`, { classname: `bg-dark text-danger p-3 fs-5`, delay: 3000 });
      return;
    }
    if(this.password.length == 0){
      this.toastService.show(`Please enter an password to login.`, { classname: `bg-dark text-danger p-3 fs-5`, delay: 3000 });
      return;
    }
    this.authService.login(this.email, this.password)
    .pipe(take(1))
    .subscribe(async (result) => {
      if (result) {
        await this.rolesService.fetchRoles();
        await this.signalRService.restartConnection();
        // Check if there's a pending remote planogram token
        this.authService.checkPendingPlanogramRedirect().subscribe(planogram => {
          // Priority 1: Pending remote planogram from backend
          if (planogram) {
            this.router.navigate([`/planogram/${planogram.guid}`]);
          } 
          else if (this.authService.redirectUrl) {
            // Priority 2: Return URL captured by Guard
            const url = this.authService.redirectUrl;
            this.authService.redirectUrl = null;
            this.router.navigateByUrl(url);
          } 
          else {
            this.router.navigate([`/`]);
          }
        });
      } else {
        this.rolesService.resetRoles();
        // notify the user their login was unsuccessfull
        this.toastService.show(`Login failed, please check your username and password`, { classname: `bg-dark text-danger p-3 fs-5`, delay: 3000 });
        //reset password field
        this.password = '';
      }
    });
  }

  resetPassword(){
      this.router.navigate(['/reset-password']);
  }

  validateEmail(): boolean {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(this.email);
  }
}
